export default __webpack_public_path__ + "static/media/book.aa5daa4e.svg";